import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'radial-progress',
  templateUrl: 'radial-progress.component.html',
  styleUrls: ['radial-progress.component.scss']
})
export class RadialProgressComponent {
  @Input() percent: number = 0;

  @HostBinding('class.radial-progress') progressClass: boolean = true;

  progressCircleRadius: number = 50;

  get radialProgress(): number {
    return this.circleCircuit -
           (this.circleCircuit * this.percent / 100);
  }

  get circleCircuit(): number {
    return Math.round(this.progressCircleRadius * 2 * Math.PI);
  }

}
